<template>
  <div class="content-builder">

    <div class="form-group">
      <ul class="nav nav-tabs" role="tablist">
        <li v-for="(block, key) in blocks" :key="key" class="nav-item" role="presentation"><a
            :class="['nav-link', {'active' : key === 'left'}]"
            :href="'#block-' + key"
            aria-controls="left"
            data-toggle="tab"
            role="tab">{{
            block.label
          }}</a></li>
      </ul>

      <div class="tab-content">

        <div v-for="(block, key) in blocks" :id="'block-' + key" :key="key"
             :class="['tab-pane', { 'active': key === 'left' }]" role="tabpanel">

          <div class="tab-options">
            <div class="type-select">
              <label class="control-label">Block Type: </label>
              <label class="radio-inline">
                <input v-model="block.type" :name="'block-' + key" type="radio" value="text"> Text
              </label>
              <label class="radio-inline">
                <input v-model="block.type" :name="'block-' + key" type="radio" value="image"> Image
              </label>
              <label class="radio-inline">
                <input v-model="block.type" :name="'block-' + key" type="radio" value="video"> Video
              </label>
            </div>
            <div class="style-select">
              <label>Block Style: </label>
              <select id="exampleFormControlSelect1" v-model="block.style" class="form-control">
                <option value="standard">Standard</option>
                <option value="callout">Callout</option>
                <option value="voice">Voice Callout</option>
              </select>
            </div>
          </div>

          <div v-show="block.type === 'text'" class="p-2">
            <textarea :ref="'block-' + key" v-model="blocks[key].content" class="summernote"
            >{{blocks[key].content}}</textarea>
          </div>

          <div v-show="block.type === 'image'" class="image-select">
            <div class="input-group">
              <div class="input-group-prepend">
                <a :data-input="'image-' + key" class="btn btn-primary text-white" data-lfm="image">
                  <i class="fa fa-image-o"></i> Choose
                </a>
              </div>
              <input :id="'image-' + key" v-model.lazy="block.image" class="form-control" type="text">
            </div>
            <img v-show="block.image" :src="block.image" class="image-preview">
          </div>
          <div v-show="block.type === 'video'" class="p-2">
            <VideoSelector :videoId="block.content?.videoId" :idIndex="`video-select-${key}`" @handleChange="handleVideoChange($event, block)" />
          </div>
        </div>

      </div>
    </div>

    <div class="form-group">
      <label class="control-label" for="audio">Audio</label>

      <div class="input-group">
        <div class="input-group-prepend">
          <a class="btn btn-primary text-white" data-input="audio" data-lfm="file">
            <i class="fa fa-audio-o"></i> Choose
          </a>
        </div>
        <input id="audio" v-model.lazy="content.audio" class="form-control" type="text">
      </div>
    </div>

    <div class="form-group">
      <label class="control-label" for="transcript">Audio Transcript</label>
      <textarea v-model="content.transcript" class="form-control"></textarea>
    </div>

    <div class="form-group card-metrics">
      <label class="control-label" for="metrics">Meter Effects (optional)</label>
      <div class="row">
        <div v-for="meter in meters" :key="meter.id" class="col-sm-2">
          <span :class="['badge', 'badge-primary', meter.id]">{{ meter.id }}</span>
          <input :id="meter.id" v-model="meter.value" class="form-control" type="number">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import _ from 'lodash'
import layoutMixin from '../../mixins/layout'
import {defaultMeters} from '../../../common/metrics'
import VideoSelector from '../VideoSelector.vue'
import Video from '../../../common/video'

export default {
  mixins: [layoutMixin],
  components: {
    VideoSelector
  },
  data() {
    const blocks = {
      left: _.assign({
        label: 'Left Block',
        type: 'text',
        style: 'standard',
        content: ''
      }, this.source.left),
      right: _.assign({
        label: 'Right Block',
        type: 'text',
        style: 'standard',
        content: ''
      }, this.source.right)
    }
    const meters = _.get(this.source, 'meters', defaultMeters());
    console.log(blocks, this.source)
    return {
      editorConfig: {},
      blocks: blocks,
      meters: meters
    }
  },
  methods: {
    setContent() {
      _.each(this.blocks, (block, key) => {
        if (block.type === 'image') {
          block.image = block.content
        }
      })
    },
    getValue() {
      // get block data
      const content = {}

      _.each(this.blocks, (block, key) => {
        content[key] = {
          type: block.type
        }
        if (block.type === 'text') {
          content[key].content = $(this.$refs['block-' + key]).summernote('code')
          content[key].style = block.style
        } else if (block.type === 'video') {
          content[key].content = block.content
        } else if (block.type === 'image') {
          content[key].content = $('#image-' + key).val()
        } else {
          console.error('Unknown block type', block.type)
        }
      })

      content.meters = this.meters
      content.audio = $('#audio').val()
      content.transcript = this.content.transcript

      console.log('printing content')
      console.log(content)

      return content
    },
    async handleVideoChange(videoId, block) {
      if (!block.content) {
        block.content = {}
      }
      const videoClient = new Video()
      let resp = await videoClient.getVideoById(videoId)
      block.content.videoId = videoId
      block.content.libraryId = resp.bunny_library_id
      block.content.hlsUrl = resp.s3_output_hls
    }
  },
  mounted() {
    $('.summernote').summernote();
  },
}
</script>

<style lang="scss">
textarea {
  min-height: 100px;
}

.ql-toolbar, .ql-container {
  background: #FFF;
}

.tab-pane {

  &.active {
    background-color: #f5f8fa;
    border-bottom: 1px solid #ddd;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
  }

  .tab-options {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: 15px;

    label {
      margin-bottom: 0;
    }

    .type-select {

      .control-label {
        margin-bottom: 0;
        margin-right: 10px;
      }
    }

    .style-select {

      select {
        display: inline-block;
        width: auto;
      }
    }
  }

  .image-select {
    margin: 0 15px 15px;

    .image-preview {
      border: 1px solid #ddd;
      margin-top: 15px;
      max-height: 300px;
      max-width: 100%;
    }
  }
}
</style>
